var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0048 14.6662C17.0599 14.6662 18.0914 14.3533 18.9687 13.7671C19.846 13.1809 20.5297 12.3477 20.9335 11.3729C21.3373 10.3981 21.4429 9.32545 21.2371 8.29061C21.0313 7.25576 20.5232 6.30519 19.7771 5.55911C19.031 4.81302 18.0804 4.30493 17.0456 4.09909C16.0107 3.89325 14.9381 3.99889 13.9633 4.40267C12.9885 4.80645 12.1553 5.49022 11.5691 6.36752C10.9829 7.24482 10.67 8.27625 10.67 9.33137C10.67 10.7462 11.2321 12.1032 12.2326 13.1036C13.233 14.1041 14.5899 14.6662 16.0048 14.6662Z",
    fill: "#1271A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0048 17.3335C13.5288 17.3335 11.1542 18.3171 9.40336 20.068C7.65254 21.8188 6.66895 24.1934 6.66895 26.6694C6.66895 27.0231 6.80946 27.3624 7.05958 27.6125C7.30969 27.8626 7.64892 28.0031 8.00264 28.0031H24.007C24.3607 28.0031 24.6999 27.8626 24.9501 27.6125C25.2002 27.3624 25.3407 27.0231 25.3407 26.6694C25.3407 24.1934 24.3571 21.8188 22.6063 20.068C20.8555 18.3171 18.4808 17.3335 16.0048 17.3335Z",
    fill: "#1271A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/profile-placeholder.19532d1290c52b9d996dd247335a1f30.svg";
export { ForwardRef as ReactComponent };